module.exports = __webpack_public_path__ + "static/img/24.10448135.png";